import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import AccountAuthSettingList from './components/AccountAuthSettingList';

const { Cell } = ResponsiveGrid;

const AccountAuthSetting = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="帳號權限設定"
        // description="公告事項"
        breadcrumbs={[
          {
            name: '帳號管理',
          },
          {
            name: '帳號權限設定',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <AccountAuthSettingList />
    </Cell>
  </ResponsiveGrid>
);

export default AccountAuthSetting;
